// Replays an instant chat/edit timeline, revealing items one at a time.
// Required instant demos pause after each AI edit until a review status;
// final demos stream through record construction before showing the same queue.
import { useState, useEffect } from "react";

export function useTimeline(timeline, { pauseOnEdit = false } = {}) {
  const [cursor, setCursor] = useState(0); // number of items revealed
  const [reviewStatuses, setReviewStatuses] = useState({});

  useEffect(() => {
    if (cursor >= timeline.length) return;

    // Reveal every proposal produced by the current participant turn, then
    // block before the following assistant message until all of those Cards
    // have a substantive status.
    if (pauseOnEdit && cursor > 0 && timeline[cursor]?.kind === "msg") {
      const currentTurnEditIndexes = [];
      for (let index = cursor - 1; index >= 0; index -= 1) {
        if (timeline[index]?.kind !== "edit") break;
        currentTurnEditIndexes.push(index);
      }
      if (currentTurnEditIndexes.some((index) => !reviewStatuses[index])) return;
    }

    const delay = timeline[cursor].kind === "edit" ? 450 : 850;
    const t = setTimeout(() => setCursor((c) => c + 1), delay);
    return () => clearTimeout(t);
  }, [cursor, pauseOnEdit, reviewStatuses, timeline]);

  const decide = (index, status, value) =>
    setReviewStatuses((current) => ({
      ...current,
      [index]: { status, value },
    }));

  return {
    revealed: timeline.slice(0, cursor),
    done: cursor >= timeline.length,
    reviewStatuses,
    decide,
  };
}
